<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [width]="700"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>

  <form (ngSubmit)="save()" [formGroup]="form">

    <div class="dialog-line">
      <div class="label" title="Site">Site <span class="danger-color">*</span></div>
      <div class="value">
        <dx-lookup
          [dataSource]="findAllLocalSites()"
          [value]="idSelectedSite"
          valueExpr="id"
          displayExpr="libelle"
          [searchEnabled]="true"
          [placeholder]="sitePlaceholder"
          (onSelectionChanged)="onChangeSite($event)"
          [disabled]="!canModify()"
        >
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-lookup>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Libellé">Libellé <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box class='inputfield' placeholder="Libellé" formControlName="libelle"
                     [disabled]="!canModify()"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Code">Code <span class="danger-color">*</span></div>
      <div class="value">
        <dx-text-box class='inputfield' placeholder="Code" formControlName="code" [readOnly]="true"></dx-text-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Ordre">Ordre <span class="danger-color">*</span></div>
      <div class="value">
        <dx-number-box class='inputfield' placeholder="Ordre" formControlName="ordre"
                     [disabled]="!canModify()"></dx-number-box>
      </div>
    </div>

    <div class="dialog-line">
      <div class="label" title="Actif">Actif <span class="danger-color">*</span></div>
      <div class="value">
        <dx-check-box [value]="true" formControlName="actif" [disabled]="!canModify()"></dx-check-box>
      </div>
    </div>

    <div class="custom-button-container-right">
      <yo-button
        type="submit"
        iconClass="fas fa-save"
        tooltip="Enregistrer"
        [theme]="ButtonThemeEnum.SAVE"
        [hidden]="!canModify()">
      </yo-button>
      <yo-button
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()"
        tooltip="Fermer"
        iconClass="fas fa-times">
      </yo-button>
    </div>
  </form>

</dx-popup>
